package pl.zar.tikthrow.util

actual val youtubeOAuthStartUrl: String
    get() = "$apiBaseUrl/api/oauth/youtube/start?session=${currentAuthToken().orEmpty()}"

actual val tiktokOAuthStartUrl: String
    get() = "$apiBaseUrl/api/oauth/tiktok/start?session=${currentAuthToken().orEmpty()}"

actual val metaOAuthStartUrl: String
    get() = "$apiBaseUrl/api/oauth/meta/start?session=${currentAuthToken().orEmpty()}"
